import { render } from "./Slidesview_en.vue?vue&type=template&id=a40ffd5e&scoped=true"
import script from "./Slidesview_en.vue?vue&type=script&lang=js"
export * from "./Slidesview_en.vue?vue&type=script&lang=js"

import "@/assets/css/globalen.css?vue&type=style&index=0&id=a40ffd5e&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a40ffd5e"]])

export default __exports__